export default "__VITE_ASSET___vU$rx_l__"